/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxMenuComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxmenu';

/**
 * Menu
 */
@Component({
    selector: 'ngc-menu',
    template: `<jqxMenu 
                [animationShowDuration] = "animationShowDuration"
                [animationHideDuration] = "animationHideDuration"
                [animationHideDelay] = "animationHideDelay"
                [animationShowDelay] = "animationShowDelay"
                [autoCloseInterval] = "autoCloseInterval"
                [autoSizeMainItems] = "autoSizeMainItems"
                [autoCloseOnClick] = "autoCloseOnClick"
                [autoOpenPopup] = "autoOpenPopup"
                [autoOpen] = "autoOpen"
                [clickToOpen] = "clickToOpen"
                [disabled] = "disabled"
                [enableHover] = "enableHover"
                [easing] = "easing"
                [keyboardNavigation] = "keyboardNavigation"
                [minimizeWidth] = "minimizeWidth"
                [mode] = "mode"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [showTopLevelArrows] = "showTopLevelArrows"
                [source] = "source"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxMenu>`
})
export class NgcMenuComponent extends ControlComponent {
    @Input('animationShowDuration') animationShowDuration: any;
    @Input('animationHideDuration') animationHideDuration: any;
    @Input('animationHideDelay') animationHideDelay: any;
    @Input('animationShowDelay') animationShowDelay: any;
    @Input('autoCloseInterval') autoCloseInterval: any;
    @Input('autoSizeMainItems') autoSizeMainItems: any;
    @Input('autoCloseOnClick') autoCloseOnClick: any;
    @Input('autoOpenPopup') autoOpenPopup: any;
    @Input('autoOpen') autoOpen: any;
    @Input('clickToOpen') clickToOpen: any;
    @Input('disabled') disabled: any;
    @Input('enableHover') enableHover: any;
    @Input('easing') easing: any;
    @Input('keyboardNavigation') keyboardNavigation: any;
    @Input('minimizeWidth') minimizeWidth: any;
    @Input('mode') mode: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('rtl') rtl: any;
    @Input('showTopLevelArrows') showTopLevelArrows: any;
    @Input('source') source: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Menu Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcMenuComponent],
    declarations: [NgcMenuComponent, jqxMenuComponent]
})
export class NgcMenuModule {
}